import { render } from "./ModalConfirmationPlayers.vue?vue&type=template&id=7f49833b&scoped=true"
import script from "./ModalConfirmationPlayers.vue?vue&type=script&lang=js"
export * from "./ModalConfirmationPlayers.vue?vue&type=script&lang=js"

import "./ModalConfirmationPlayers.vue?vue&type=style&index=0&id=7f49833b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f49833b"

export default script